// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2LZl6","col":"Table_col__374Qq","fulfillmentStatus":"Table_fulfillmentStatus__1Q1j6","emailCol":"Table_emailCol__1ikP0"};